import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/loan-repayment/:key?',
    name: 'estimateLoanRepayment',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/estimateLoanRepayment/EstimateLoanRepayment.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.STC],
    },
  }
];
